import React from "react";
import { Toaster } from "sonner";

import { AppProviders } from "./AppProviders";
import AppRouting from "./AppRouting";

function App() {
  return (
    <AppProviders>
      <AppRouting />
      <Toaster />
    </AppProviders>
  );
}

export default App;
